import React from 'react';
import styles from './index.module.scss';

const UserAgreementPage = () => {
  return (
    <main className={styles.container}>
      <section>
        <h1>BF Island User Agreement</h1>
        <p>Effective Date: January 30, 2026</p>
        <br />
        <p>
          This User Agreement (collectively with BF Island&rsquo;s Privacy
          Policy, DMCA Copyright Policy, and End User License Agreement,
          collectively the &quot;User Agreement&quot;) applies to your use of BF
          Island mobile application, services, content, features, and properties
          (collectively, &quot;BF Island&quot;). BF Island is provided by
          BuzzFeed Media Enterprises, Inc., or the relevant BuzzFeed subsidiary
          or affiliate company (&quot;BuzzFeed&quot;, &quot;we&quot;,
          &quot;us&quot;, or &quot;our&quot;). Please read this User Agreement
          carefully as it sets forth the legally binding terms and conditions
          for your use of BF Island.
        </p>
        <p>
          THIS USER AGREEMENT CONTAINS A CLASS ACTION WAIVER. BY ACCEPTING THESE
          TERMS, YOU EXPRESSLY AGREE TO BE BOUND BY AND ABIDE BY THIS AGREEMENT,
          INCLUDING THE CLASS ACTION WAIVER PROVISION.
        </p>
        <h2>Acceptance of User Agreement</h2>
        <ol>
          <li>
            By registering for and/or using BF Island in any manner, you agree
            to our User Agreement and all other operating rules, policies and
            procedures that may be published from time to time by us, each of
            which is incorporated by reference and each of which may be updated
            from time to time without notice to you. In turn, BF Island grants
            you a non-assignable, non-sublicensable, non-transferable,
            non-exclusive, revocable license to use BF Island in accordance with
            this User Agreement.
          </li>
          <li>
            Certain features on BF Island may be subject to additional terms and
            conditions specified by us from time to time or as required by law;
            your use of such features is subject to those additional terms and
            conditions, which are incorporated into this User Agreement by this
            reference.
          </li>
          <li>
            This User Agreement applies to all users of BF Island, including,
            without limitation, users who are contributors of content,
            information, and other materials or services, registered or
            otherwise.
          </li>
        </ol>
        <h2>CLASS ACTION WAIVER</h2>
        <p>
          PLEASE REVIEW AS THIS AFFECTS YOUR LEGAL RIGHTS, INCLUDING YOUR RIGHT
          TO OBTAIN RELIEF OR DAMAGES AS A MEMBER OF A CLASS.
        </p>
        <p>
          You agree that you will not sue BuzzFeed as a class plaintiff or class
          representative, join as a class member, or participate as an adverse
          party in any way in a class action lawsuit against BuzzFeed. Nothing
          in this paragraph, however, limits your rights to bring a lawsuit as
          an individual plaintiff.
        </p>
        <h2>Eligibility</h2>
        <p>
          If you are below the age of consent under applicable law in the state
          or country in which you reside, then your parent or legal guardian
          must read and accept the terms and conditions of this User Agreement
          in your name and on your behalf.
        </p>
        <p>
          In the U.S., you must be at least 13 years of age to use BF Island. By
          using BF Island, you represent and warrant that you are at least 13
          years of age. If you are under age 13, you may not, under any
          circumstances or for any reason, use BF Island. BF Island does not
          target nor is it meant for anyone under 13 years of age. If we have
          actual knowledge that you are under the age of 13 (or the minimum age
          at which a person may use BF Island in your state, province, or
          country without parental consent, if greater), we will cease providing
          BF Island to you and delete your account and your data. If you become
          aware of anyone using BF Island who is under the age of 13 and/or the
          minimum age allowed by your state, province, or country, please report
          this to:{' '}
          <a href="mailto:support@bfisland.com">support@bfisland.com</a>. We do
          not knowingly collect information from anyone under the age of 13.
        </p>
        <p>
          We may, at our sole discretion, refuse to offer BF Island to any
          person or entity for any reason. We may also change our eligibility
          criteria at any time, at our sole discretion. You are solely
          responsible for ensuring that your use of BF Island is in compliance
          with all laws, rules and regulations applicable to you. Further, BF
          Island is offered only for your personal use, and not for the use or
          benefit of any third party.
        </p>
        <h2>Registration</h2>
        <p>
          You must register for an account on BF Island (an &quot;Account&quot;)
          or log in using your BuzzFeed, Apple, or Google login information.
          When you register for an Account, you must provide accurate and
          complete information as required during the registration process,
          including your correct date of birth. You represent and warrant that
          the date of birth you provide accurately reflects your actual birth
          date. You shall not: (i) choose a username that is the name of another
          person, with the intent to impersonate that person; (ii) choose a
          username that is subject to any rights of a person other than you
          without appropriate authorization; or (iii) choose a username that is
          otherwise offensive, vulgar or obscene.
        </p>
        <p>
          You are solely responsible for all of the activity that occurs on your
          Account, and for keeping your Account password secure. In no event
          shall we be liable for any loss, theft or fraudulent use of your
          Account. You may never use another person&rsquo;s user account or
          registration information for BF Island without their permission. You
          must notify us immediately of any change in your eligibility to use BF
          Island, breach of security, or unauthorized use of your Account. You
          should never publish, distribute or post login information for your
          Account. You shall have the ability to delete your Account. Please go
          to our Consent Preferences Center at{' '}
          <a
            href="https://www.buzzfeed.com/consent-preferences"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://www.buzzfeed.com/consent-preferences
          </a>{' '}
          for more information on Account deletion.
        </p>
        <p>
          By using our BF Island through Apple or Google, you permit us to
          access certain information from your Apple or Google account for use
          by BF Island. You may control the amount of information that is
          accessible to us by adjusting your Apple or Google account privacy
          settings. By using BF Island, you are authorizing us to collect,
          store, retain, and use, any and all information that you permitted
          Apple or Google to provide to us in accordance with our Privacy
          Policy.
        </p>
        <h2>Media and Content</h2>
        <p>
          To use BF Island&rsquo;s artifact generator, you provide an input in
          the form of text, image, and/or audio (collectively,
          &quot;Input&quot;) to generate a text, image, or audio output
          (collectively &quot;Output&quot;). Both Input and Output are
          collectively referred to as &quot;Artifacts&quot;. We do not adopt,
          endorse, or assume responsibility for any Output, including any
          third-party references, generated by BF Island.
        </p>
        <p>
          Through BF Island, you can communicate and interact with other BF
          Island users. For purposes of this User Agreement, the term
          &quot;Media&quot; includes, without limitation, any communications
          (and content thereof), comments, messages, text, photographs and
          Artifacts generated, provided, or otherwise made accessible on or
          through BF Island by you to other BF Island users.
        </p>
        <h3>Intellectual Property Rights and Licenses</h3>
        <h4>a. You will not violate any applicable laws or regulations</h4>
        <p>
          By inputting, posting, sharing, transmitting, or sharing Media on or
          through BF Island, you represent and warrant that: (i) the Media is
          yours (you own it) and/or you have the right to use it (by means of a
          license or other permission) and the right, license, or permission to
          grant us the license as provided in this User Agreement, and (ii) that
          the posting of your Media on or through BF Island does not violate the
          privacy rights, publicity rights, intellectual property rights,
          contract rights or any other rights of any person or entity
          (collectively, &quot;Third Party Rights&quot;). You shall be solely
          responsible and liable for any violation, misappropriation, breach,
          infringement or otherwise of Third Party Rights and agree to fully
          indemnify us described below.
        </p>
        <p>
          BF Island may contain and make available for use content specifically
          provided by us and our partners (&quot;Content&quot;), and such
          Content may be protected by copyrights, trademarks, service marks,
          patents, trade secrets, or other proprietary rights and laws. You
          shall abide by all copyright or other legal notices, information, and
          restrictions contained in any Content accessed through BF Island
          (&quot;Protected Content&quot;). The trademarks, logos, trade names,
          trade dress, and service marks, whether registered or unregistered
          (collectively the &quot;Trademarks&quot;) displayed on BF Island are
          Trademarks of BuzzFeed and its third party partners. Nothing contained
          on BF Island shall be construed as granting by implication or
          otherwise, any license or right to use any Protected Content or
          Trademarks displayed on BF Island without the written permission of
          BuzzFeed or such third party that may own the Protected Content or
          Trademarks. Any unauthorized commercial use of the Protected Content
          or Trademarks may violate the intellectual property rights of BuzzFeed
          and/or third parties associated with BuzzFeed and will be subject to
          BuzzFeed&rsquo;s and/or those third party&rsquo;s full legal rights
          and remedies.
        </p>
        <p>
          We reserve the right to terminate your account if we find you to be
          infringing, misappropriating, and otherwise violating Third Party
          Rights.
        </p>
        <h4>b. User-Submitted Selfies</h4>
        <p>
          BF Island allows users to upload, post, transmit, or otherwise make
          available photographic self-portraits or images depicting themselves
          (&quot;Selfies&quot;), a sub-type of Media. Submission of any Selfie
          is entirely voluntary. BY SUBMITTING A SELFIE, YOU EXPRESSLY
          ACKNOWLEDGE AND AGREE THAT YOU HAVE NO EXPECTATION OF PRIVACY IN SUCH
          SELFIE AND THAT, TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW,
          YOU IRREVOCABLY WAIVE AND RELEASE ANY AND ALL PRIVACY, PUBLICITY, OR
          PERSONAL DATA RIGHTS YOU MAY HAVE WITH RESPECT TO SUCH SELFIE. You are
          solely responsible for determining whether to submit a Selfie and for
          any consequences arising from its submission. If you do not wish your
          image, likeness, or biometric information to be collected, used,
          reproduced, commercialized, or publicly disclosed without restriction,
          you must not upload a Selfie to BF Island.
        </p>
        <p>
          You understand and agree that once a Selfie is submitted, it may be
          copied, redistributed, altered, or further disseminated by third
          parties (e.g. other BF Island users), and that such dissemination may
          be impossible to control or retract. You assume all risks associated
          with the submission of any Selfie, including risks of unauthorized
          access, disclosure, identity misuse, reputational harm, or other
          consequences.
        </p>
        <p>
          You acknowledge that a Selfie may contain biometric identifiers or
          biometric information (e.g., facial geometry) as defined under certain
          U.S. state laws, including but not limited to the Illinois Biometric
          Information Privacy Act (740 ILCS 14/1 et seq.) and similar statutes
          enacted in Texas or Washington.
        </p>
        <p>
          BuzzFeed has no obligation to remove, delete, restrict access to, or
          cease use of any Selfie once submitted, and you acknowledge that
          deletion requests may not result in complete or comprehensive removal
          from all systems, backups, archives, or third-party platforms.
        </p>
        <p>
          You are solely responsible for determining whether to submit a Selfie
          and for any consequences resulting therefrom. If you do not wish your
          image to be publicly accessible, reproduced, commercialized, or
          otherwise used without restriction, you must not upload a Selfie to
          the Platform.
        </p>
        <h4>c. You provide us with licenses to what you own</h4>
        <p>
          As between you and BuzzFeed, and to the extent permitted by applicable
          law, you acknowledge and agree that you (a) retain your ownership
          rights in your Media (excluding Outputs) and (b) own the Output
          generated through BF Island. To the extent we own any Media by law,
          contract, or otherwise, BuzzFeed hereby assigns to you all our right,
          title, and interest, if any, in and to any Artifacts subject to any
          rights you license to us, as described below.
        </p>
        <p>
          By inputting, posting, sharing, transmitting, or sharing Media on or
          through BF Island, you grant us a a worldwide, non-exclusive,
          irrevocable, perpetual, royalty-free, fully paid, sublicensable and
          transferable, license to use, edit, modify, truncate, prepare
          derivative works, aggregate, reproduce, distribute, display, perform,
          and otherwise fully exploit your Media, including your name, likeness,
          image, voice (if applicable), and any other identifiable aspects
          embodied in your Selfie, without any attribution to you in any media
          formats (known or later developed) and through any media channels
          (including, without limitation, third party websites and feeds),
          including after your termination of your Account on BF Island without
          notice, approval or compensation. You expressly waive and release any
          claims under applicable rights of publicity, misappropriation of
          likeness, or similar state law doctrines.
        </p>
        <p>
          For the sake of clarity, the foregoing license grant includes our
          right to distribute, display, modify, perform and otherwise use the
          Media in connection with material provided to or by our advertisers
          and other business partners, and you shall not be entitled to any
          remuneration for such use. You further agree that the license to use
          your Media extends to us to operate and improve BF Island, and/or to
          allow trusted partners to use your Media to support, enhance, and
          monetize BF Island. To the extent any Media you submit includes any
          biographical information, including your name, likeness, voice, or
          photograph, you acknowledge and agree that this license shall apply to
          the same.
        </p>
        <h4>Terms of Use.</h4>
        <p>
          BF Island is solely for personal use. You agree that you shall not
          sell, license, rent, or otherwise use or exploit BF Island, any Media,
          or any Content for commercial use or in any way that violates any
          Third Party Rights. You may post your Outputs on third party
          platforms, subject to your compliance with such third party
          platforms&rsquo; user agreements and applicable laws. You hereby
          indemnify BuzzFeed and its affiliates for any violation of third party
          platforms&rsquo; user agreements and all applicable laws, including
          data privacy, intellectual property, and rights of publicity/privacy
          laws.
        </p>
        <p>
          BF Island may be supported by advertising revenue and may display
          advertisements and promotions. You hereby agree that BuzzFeed may
          place such advertising and promotions in connection with, on, or
          adjacent to your Media. The manner, mode and extent of such
          advertising and promotions are subject to change without specific
          notice to you.
        </p>
        <p>
          You agree that BuzzFeed may remove, block, or modify your Media or any
          Content if we believe that they violate this User Agreement,
          applicable laws, or other applicable policies.
        </p>
        <p>
          Except where prohibited by applicable law, by submitting Media through
          BF Island, you are waiving and agreeing not to assert any trademarks,
          copyrights, rights of publicity, privacy, or &quot;moral&quot; rights
          or claims resulting from our alteration of the Media or any
          photograph(s), footage, illustrations, statements or other work
          contained in the Media. You also agree to appoint BuzzFeed as your
          irrevocable attorney-in-fact with respect to your Media. BuzzFeed has
          the right to execute and deliver any documents in your name and on
          your behalf, to ensure that BuzzFeed can use the Media that you are
          licensing to BuzzFeed, to protect the rights in any derivative works
          created from your Media, and to have the Media removed from any other
          website or forum.
        </p>
        <p>
          You agree to execute and deliver any such additional documents that
          BuzzFeed deems reasonably necessary to establish our ability to use
          the Media as we see fit and that &quot;Moral Rights of Authors&quot;
          are waived under this User Agreement unless prohibited by applicable
          law and upon request from BuzzFeed. Should BuzzFeed fail to request
          any licenses or other documents, that shall not be deemed a waiver of
          BuzzFeed&rsquo;s rights and we may request any such documents at a
          later time.
        </p>
        <h4>Use Media at your Own Risk.</h4>
        <p>
          We do not guarantee that any Media or Content will be made available
          on or through BF Island. You acknowledge that all use, sharing,
          uploading, posting, or otherwise of any Media by you on BF Island is
          at your own risk and you will be solely responsible for any damage or
          loss to you or any other party resulting from your actions. You agree
          that BuzzFeed does not control how others may use your Media, and you
          further agree that BuzzFeed is not obligated to actively monitor or
          control how third parties use or exploit your Media.
        </p>
        <h2>Rules of Conduct</h2>
        <p>
          As a condition of use, you promise not to use BF Island for any
          purpose that is prohibited by this User Agreement. You are responsible
          for all of your activity in connection with BF Island. You shall not
          (and shall not permit any third party to) either (a) take any action
          or (b) upload, download, post, submit or otherwise distribute or
          facilitate distribution of any Content on or through BF Island,
          including without limitation any Media or Content, that:
        </p>
        <ol>
          <li>
            infringes any patent, trademark, trade secret, copyright, right of
            publicity or other right of any other person or entity or violates
            any law or contractual duty (see our DMCA Copyright Policy);
          </li>
          <li>you know is false, misleading, untruthful or inaccurate;</li>
          <li>
            is unlawful, threatening, abusive, harassing, defamatory, libelous,
            deceptive, fraudulent, invasive of another&rsquo;s privacy,
            tortious, obscene, vulgar, pornographic, offensive, profane,
            contains or depicts nudity, contains or depicts sexual activity, or
            is otherwise inappropriate as determined by us at our sole
            discretion;
          </li>
          <li>
            depicts an individual in a false, misleading, or deceptive manner or
            that is likely to cause emotional distress;
          </li>
          <li>
            Impersonates or misrepresents to be any person or entity, including
            any of our employees or representatives;
          </li>
          <li>
            includes anyone&rsquo;s private or personal data (as defined in our
            Privacy Policy), identification documents, or other sensitive
            information, without having their prior consent;
          </li>
          <li>
            depicts any minor under the age of 18 engaging in or simulating
            sexual conduct of any kind;
          </li>
          <li>suggests or depicts any harm or cruelty to any animal;</li>
          <li>
            Celebrates, glorifies, normalizes, or encourages any cruelty to
            individuals, class of people, or animals;
          </li>
          <li>
            constitutes unauthorized or unsolicited advertising, junk or bulk
            e-mail (&quot;spamming&quot;); or
          </li>
          <li>
            contains software viruses or any other computer codes, files, or
            programs that are designed or intended to disrupt, damage, limit or
            interfere with the proper function of any software, hardware, or
            telecommunications equipment or to damage or obtain unauthorized
            access to any system, data, password or other information of ours or
            of any third party.
          </li>
        </ol>
        <p>
          If an individual requests the removal of Media targeting them, we will
          review and take action. We reserve the right to remove any Media that
          we, at our sole discretion, believe to violate this User Agreement.
        </p>
        <p>
          You shall not: (i) take any action that imposes or may impose (as
          determined by us at our sole discretion) an unreasonable or
          disproportionately large load on our (or our third party
          providers&rsquo;) infrastructure; (ii) interfere or attempt to
          interfere with the proper working of BF Island or any activities
          conducted on BF Island; (iii) bypass, circumvent or attempt to bypass
          or circumvent any measures we may use to prevent or restrict access to
          BF Island (or other accounts, computer systems or networks connected
          to BF Island); (iv) run any form of auto-responder or &quot;spam&quot;
          on BF Island; (v) use manual or automated software, devices, or other
          processes to &quot;crawl&quot; or &quot;spider&quot; any page of BF
          Island; (vi) harvest or scrape any Media or Content from BF Island; or
          (vii) otherwise take any action in violation of our guidelines and
          policies.
        </p>
        <p>
          You shall not (directly or indirectly): (i) decipher, decompile,
          disassemble, reverse engineer or otherwise attempt to derive any
          source code or underlying ideas or algorithms of any part of BF Island
          (including without limitation any application), except to the limited
          extent applicable laws specifically prohibit such restriction; (ii)
          modify, translate, or otherwise create derivative works of any part of
          BF Island; or (iii) copy, rent, lease, distribute, or otherwise
          transfer any of the rights that you receive hereunder. You must abide
          by all applicable local, state, national and international laws and
          regulations.
        </p>
        <p>
          We also reserve the right to access, read, preserve, and disclose any
          information as we reasonably believe is necessary to: (i) satisfy any
          applicable law, regulation, legal process or governmental request;
          (ii) enforce this User Agreement, including investigation of potential
          violations hereof; (iii) detect, prevent, or otherwise address fraud,
          security or technical issues; (iv) respond to user support requests;
          or (v) protect the rights, property or safety of us, our users and the
          public.
        </p>
        <h2>Moderation and Conduct</h2>
        <p>
          By using BF Island, you may be exposed to content or conduct that is
          offensive, indecent, or otherwise not in line with your values.
          BuzzFeed may utilize technology to monitor and/or record your
          interactions or communications within BF Island (including, but not
          limited to, chat text or voice communications). You irrevocably
          consent to such monitoring and recording and agree that you have no
          expectation of privacy concerning the transmission of any content
          within BF Island, including, but not limited to, chat text or voice
          communications. You understand that your communications within BF
          Island, and/or your interactions with BF Island may be displayed to or
          viewable by other users of BF Island or the general public.
        </p>
        <p>
          We proactively use automated tools and human moderation to detect and
          act on prohibited content. BF Island prioritizes the swift removal of
          terrorism content, child sexual exploitation and abuse (CSEA) content,
          and other priority illegal content. This proactive technology includes
          tools that help us recognize hashes of known illegal content and that
          can detect violations of our terms based on the text in and content of
          a post. We also rely on user reports, trusted flaggers, and law
          enforcement reports. When notified, we act promptly to investigate
          exposure. Except as otherwise expressly stated, BuzzFeed assumes no
          responsibility for the conduct of other users of BF Island or for
          monitoring BF Island for inappropriate content or conduct. BuzzFeed
          does not, and cannot, pre-screen or monitor all content or conduct of
          users. Your use of BF Island is at your own risk.
        </p>
        <p>
          BuzzFeed reserves the right at its sole discretion to review, monitor,
          prohibit, edit, delete, disable access to, or otherwise make
          unavailable any content or Media made available by users of BF Island
          without notice. BuzzFeed may choose to take such action to prevent
          hacking or cheating, to ensure compliance with and to enforce this
          User Agreement, to improve BF Island, for any other reason or for no
          reason. In doing so, BuzzFeed may employ automated technologies or
          systems, including, but not limited to, machine learning or artificial
          intelligence-based solutions, for example, to detect and prevent the
          submission or distribution of words, images, or other content that
          violate this User Agreement or applicable law. If at any time BuzzFeed
          chooses, at its sole discretion, to monitor BF Island, BuzzFeed
          nonetheless assumes no responsibility for content made available by
          users of BF Island, and BuzzFeed assumes no obligation to modify or
          remove any inappropriate content, except as may be required by
          applicable law.
        </p>
        <p>
          BF Island may allow you to control interactions with other users, for
          example by opting in to or out of social features, &quot;muting&quot;
          or &quot;blocking&quot; other users, or reporting the content or
          conduct of other users.
        </p>
        <p>
          You acknowledge that BuzzFeed is not a party to any dispute you may
          have with any other user(s) of BF Island. BuzzFeed has no obligation
          to become involved in any such dispute. You release BuzzFeed and its
          subsidiaries and affiliates (and BuzzFeed&rsquo;s and its
          subsidiaries&rsquo; and affiliates&rsquo; officers, directors, agents,
          joint ventures, shareholders and employees) from all claims, demands,
          and damages related to any such dispute.
        </p>
        <h2>Additional Terms May Apply</h2>
        <p>
          Depending on the Content or features included in BF Island, additional
          terms may apply (&quot;Additional Terms&quot;). Additional Terms may
          also apply for promotions, sweepstakes, contests, giveaways, or
          similar programs. If this User Agreement is inconsistent with any
          Additional Terms, the Additional Terms will control.
        </p>
        <h2>Our Communications to You</h2>
        <p>
          We may communicate with you electronically, including by posting
          notices on BF Island or by responding to your emails. You agree that
          all agreements, notices, disclosures or other communications that we
          provide to you electronically satisfy any legal requirement that such
          communications be in writing.
        </p>
        <h2>Feedback and Unsolicited Material</h2>
        <p>
          Any feedback, comments, or suggestions you may provide regarding BF
          Island is entirely voluntary and we will be free to use such feedback,
          comments or suggestions as we see fit and without any compensation or
          obligation to you.
        </p>
        <h2>Account Deletion or Termination</h2>
        <h3>Deletion</h3>
        <p>
          If you wish to terminate your Account, you may do so by following the
          instructions on BF Island or send us a request through{' '}
          <a href="mailto:support@bfisland.com">support@bfisland.com</a>. In the
          event you elect to delete your account, we will use commercially
          reasonable efforts to process such deletion in accordance with
          applicable law and our Privacy Policy. Notwithstanding the foregoing,
          any Outputs generated by you through BF Island will be retained, and
          any license granted to us pursuant to this User Agreement shall
          survive and remain in full force and effect.
        </p>
        <h3>Termination.</h3>
        <p>
          We may terminate your access to all or any part of BF Island at any
          time, with or without cause, with or without notice, effective
          immediately, which may result in the forfeiture and destruction of
          some or all Media associated with your Account. All provisions of this
          User Agreement which by their nature should survive termination shall
          survive termination, including, without limitation, licenses of Media,
          ownership provisions, warranty disclaimers, indemnity and limitations
          of liability.
        </p>
        <h2>Warranty Disclaimer</h2>
        <p>
          We have no special relationship with or fiduciary duty to you. You
          acknowledge that BuzzFeed has no duty to take any action regarding:
        </p>
        <ol>
          <li>which users gain access to BF Island;</li>
          <li>what Media or Content is accessible via BF Island; or</li>
          <li>how you may use BF Island.</li>
        </ol>
        <p>
          BF ISLAND, ANY MEDIA, AND CONTENT ARE PROVIDED &quot;AS IS&quot;,
          &quot;AS AVAILABLE,&quot; AND WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
          IMPLIED, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
          TITLE, NON-INFRINGEMENT, MERCHANTABILITY AND FITNESS FOR A PARTICULAR
          PURPOSE, AND ANY WARRANTIES IMPLIED BY ANY COURSE OF PERFORMANCE OR
          USAGE OF TRADE, ALL OF WHICH ARE EXPRESSLY DISCLAIMED. WE, OUR
          AFFILIATES, AND OUR RESPECTIVE PREDECESSORS, SUCCESSORS, ASSIGNEES,
          ASSIGNORS, DIRECTORS, OFFICERS, EMPLOYEES, AGENTS, SUPPLIERS,
          PARTNERS, CONTRACTORS, AND CONTENT PROVIDERS (COLLECTIVELY, THE
          &quot;BUZZFEED ENTITIES&quot;) DO NOT REPRESENT OR WARRANT THAT: (I)
          BF ISLAND WILL BE SECURE OR AVAILABLE AT ANY PARTICULAR TIME OR
          LOCATION; (II) ANY DEFECTS OR ERRORS WILL BE CORRECTED; (III) ANY
          MEDIA, CONTENT, OR SOFTWARE AVAILABLE AT OR THROUGH BF ISLAND IS FREE
          OF VIRUSES OR OTHER HARMFUL COMPONENTS; OR (IV) THE RESULTS OF USING
          BF ISLAND WILL MEET YOUR REQUIREMENTS. YOUR USE OF BF ISLAND IS SOLELY
          AT YOUR OWN RISK. PLEASE NOTE THAT SOME JURISDICTIONS MAY NOT ALLOW
          THE EXCLUSION OF IMPLIED WARRANTIES, SO SOME OF THE ABOVE EXCLUSIONS
          MAY NOT APPLY TO YOU.
        </p>
        <h2>Indemnification.</h2>
        <p>
          You shall fully defend, indemnify, and hold harmless the BuzzFeed
          Entities from all liabilities, claims, and expenses, including
          reasonable attorneys&rsquo; fees, that arise from or relate to: (i)
          your use or misuse of, or access to, BF Island, Content, Trademarks,
          or otherwise from your Media (ii) any violation of this User
          Agreement, or any infringement by you of any intellectual property or
          other right of any person or entity; or (iii) any third party using
          your Account or identity in BF Island. We reserve the right to assume
          the exclusive defense and control of any matter otherwise subject to
          indemnification by you, in which event you will assist and cooperate
          with us in asserting any available defenses.
        </p>
        <h2>Limitation of Liability.</h2>
        <p>
          IN NO EVENT SHALL THE BUZZFEED ENTITIES BE LIABLE UNDER CONTRACT,
          TORT, STRICT LIABILITY, NEGLIGENCE OR ANY OTHER LEGAL OR EQUITABLE
          THEORY WITH RESPECT TO BF ISLAND, ANY MEDIA, OR CONTENT: (I) FOR ANY
          LOST PROFITS, DATA LOSS, COST OF PROCUREMENT OF SUBSTITUTE GOODS OR
          SERVICES, OR SPECIAL, INDIRECT, INCIDENTAL, PUNITIVE, COMPENSATORY, OR
          CONSEQUENTIAL DAMAGES OF ANY KIND WHATSOEVER, SUBSTITUTE GOODS OR
          SERVICES (HOWEVER ARISING); (II) FOR ANY BUGS, VIRUSES, TROJAN HORSES,
          OR THE LIKE (REGARDLESS OF THE SOURCE OF ORIGINATION); OR (III) FOR
          ANY DIRECT DAMAGES IN EXCESS OF (IN THE AGGREGATE) $500.00. APPLICABLE
          LAW MAY NOT ALLOW THE LIMITATION OR EXCLUSION OF LIABILITY OR
          INCIDENTAL OR CONSEQUENTIAL DAMAGES, SO THE ABOVE LIMITATION OR
          EXCLUSION MAY NOT APPLY TO YOU.
        </p>
        <p>
          WITHOUT LIMITING THE FOREGOING AND FOR THE AVOIDANCE OF DOUBT, TO THE
          FULLEST EXTENT PERMITTED BY LAW, THE COMPANY SHALL HAVE NO LIABILITY
          WHATSOEVER FOR ANY UNAUTHORIZED ACCESS TO, USE OF, DISCLOSURE OF,
          ALTERATION OF, LOSS OF, OR DISTRIBUTION OF ANY SELFIE, INCLUDING ANY
          PERSONAL DATA OR BIOMETRIC INFORMATION CONTAINED THEREIN, WHETHER
          ARISING FROM A DATA BREACH, CYBERATTACK, SYSTEM FAILURE, THIRD-PARTY
          ACTION, OR OTHERWISE. YOU EXPRESSLY RELEASE AND HOLD HARMLESS THE
          COMPANY FROM ANY CLAIMS, DAMAGES, LOSSES, LIABILITIES, COSTS, OR
          EXPENSES ARISING OUT OF OR RELATING TO YOUR SUBMISSION OF A SELFIE.
        </p>
        <h2>Legal Disputes.</h2>
        <p>
          PLEASE READ THIS SECTION CAREFULLY. IT AFFECTS YOUR RIGHTS AND WILL
          HAVE A SUBSTANTIAL IMPACT ON HOW CLAIMS YOU AND BUZZFEED HAVE AGAINST
          EACH OTHER ARE RESOLVED.
        </p>
        <p>
          You and BuzzFeed agree that any and all claims or disputes at law or
          equity that has arisen, or may arise, between you and BuzzFeed (or any
          BuzzFeed Entities) that relate in any way to or arise out of this User
          Agreement or your use of or access to BF Island will be resolved in
          accordance with the provisions set forth in this Legal Disputes
          section.
        </p>
        <p>Applicable Law</p>
        <p>
          You and BuzzFeed agree that, except to the extent inconsistent with or
          preempted by federal law, the laws of the State of New York, without
          regard to principles of conflict of laws, will govern this User
          Agreement and any claim or dispute that has arisen or may arise
          between you and BuzzFeed or a BuzzFeed Entity, except as otherwise
          stated in this User Agreement.
        </p>
        <h2>Miscellaneous</h2>
        <h4>Entire Agreement and Severability.</h4>
        <p>
          This User Agreement is the entire agreement between you and us with
          respect to BF Island and any Media, including use of BF Island and
          creation of any Media, and supersedes all prior or contemporaneous
          communications and proposals (whether oral, written or electronic)
          between you and us with respect to BF Island and any Media. If any
          provision of this User Agreement is found to be unenforceable or
          invalid, that provision will be limited or eliminated to the minimum
          extent necessary so that this User Agreement will otherwise remain in
          full force and effect and enforceable.
        </p>
        <h4>Headings.</h4>
        <p>
          The section and paragraph headings in this User Agreement are for
          convenience only and shall not affect their interpretation.
        </p>
        <h4>Import and Export Jurisdiction.</h4>
        <p>
          Content and software from BF Island may be subject to U.S. export
          jurisdiction and the import jurisdiction of other countries. In
          connection with your use of BF Island, you are solely responsible for
          complying with all applicable export, re-export, and import control
          laws and regulations of all applicable jurisdictions, including, but
          not limited to, those of the U.S. Department of Commerce, Export
          Administration Regulations, 15 CFR Parts 730-774, the International
          Traffic in Arms Regulations, country-specific economic sanctions
          programs implemented by the Office of Foreign Assets Control and
          export and import control laws and regulations of any other countries.
          You may not, directly or indirectly, use, distribute, transfer or
          transmit content or software from BF Island, whether by way of a
          direct product or of such materials or products, software, or other
          technical information into which content or software from BF Island
          has been incorporated, except in compliance with all applicable export
          and import laws and regulations of all relevant jurisdictions.
        </p>
        <h4>Force Majeure.</h4>
        <p>
          We shall not be liable for any failure to perform our obligations
          hereunder where such failure results from any cause beyond our
          reasonable control, including, without limitation, mechanical,
          electronic or communications failure or degradation.
        </p>
        <h4>Assignment.</h4>
        <p>
          This User Agreement is personal to you, and is not assignable,
          transferable or sublicensable by you except with our prior written
          consent. We may assign, transfer or delegate any of our rights and
          obligations hereunder without consent.
        </p>
        <h4>Agency.</h4>
        <p>
          No agency, partnership, joint venture, or employment relationship is
          created as a result of this User Agreement and neither party has any
          authority of any kind to bind the other in any respect.
        </p>
        <h4>Notices.</h4>
        <p>
          Unless otherwise specified in this User Agreement, all notices under
          this User Agreement will be in writing and will be deemed to have been
          duly given when received, if personally delivered or sent by certified
          or registered mail, return receipt requested; when receipt is
          electronically confirmed, if transmitted by facsimile or e-mail; or
          the day after it is sent, if sent for next day delivery by recognized
          overnight delivery service. Electronic notices should be sent to{' '}
          <a href="mailto:support@bfisland.com">support@bfisland.com</a>.
        </p>
        <h4>No Waiver.</h4>
        <p>
          Our failure to enforce any part of this User Agreement shall not
          constitute a waiver of our right to later enforce that or any other
          part of this User Agreement. Waiver of compliance in any particular
          instance does not mean that we will waive compliance in the future. In
          order for any waiver of compliance with this User Agreement to be
          binding, we must provide you with written notice of such waiver
          through one of our authorized representatives.
        </p>
        <h4>Modification.</h4>
        <p>
          We reserve the right, at our sole discretion, to modify or replace any
          part of this User Agreement, or change, suspend, or discontinue BF
          Island (including without limitation, the availability of any feature,
          database, or content) at any time by posting a notice on BF Island or
          by sending you notice through BF Island, via e-mail or by another
          appropriate means of electronic communication. We may also impose
          limits on certain features and services or restrict your access to
          parts or all of BF Island without notice or liability. While we will
          timely provide notice of modifications, it is also your responsibility
          to check this User Agreement periodically for changes. Your continued
          use of BF Island following notification of any changes to this User
          Agreement constitutes acceptance of those changes.
        </p>
        <h4>Contact and Company details.</h4>
        <p>
          BuzzFeed Media Enterprises, Inc. is a Delaware corporation with its
          headquarters at 50 West 23rd Street, 6th Floor, New York City, New
          York, 10010. You may contact us at the following address: 50 West 23rd
          Street, 6th Floor, New York City, New York, 10010, or at the following
          email address:{' '}
          <a href="mailto:support@bfisland.com">support@bfisland.com</a>.
        </p>
      </section>
    </main>
  );
};
export default UserAgreementPage;
